import { useState } from 'react';
import {
  VStack, Text, Heading, Input, Button, Textarea,
} from '@chakra-ui/react';

export interface ScenarioStepData {
  name: string;
  description: string;
}

export interface ScenarioStepProps {
  onSubmit: (data: { name: string; description: string }) => void;
  initialData?: { name?: string; description?: string };
  isLoading?: boolean;
  error?: string | null;
  locationName?: string;
}

export function ScenarioStep({ onSubmit, initialData, isLoading }: ScenarioStepProps) {
  const [name, setName] = useState(initialData?.name ?? '');
  const [description, setDescription] = useState(initialData?.description ?? '');

  const handleSubmit = () => {
    if (name.trim()) {
      onSubmit({ name: name.trim(), description: description.trim() });
    }
  };

  return (
    <VStack flex={1} p={6} gap={6} bg="gray.50" data-testid="wizard-scenario-step">
      <VStack align="center" gap={2}>
        <Heading as="h2" size="xl" fontWeight="bold" color="gray.800">
          Create a scenario
        </Heading>
        <Text fontSize="md" color="gray.500" textAlign="center" maxW="400px">
          A scenario defines when and how music plays at your location. You can customize
          schedules and playlists later.
        </Text>
      </VStack>

      <VStack gap={4} w="100%" maxW="500px" alignSelf="center">
        <VStack gap={2} w="100%" align="stretch">
          <Text fontSize="sm" fontWeight="600" color="gray.800">Scenario name</Text>
          <Input
            size="md"
            placeholder="e.g., Morning Vibes, Weekend Party"
            value={name}
            onChange={(e) => setName(e.target.value)}
            data-testid="wizard-scenario-name"
          />
        </VStack>

        <VStack gap={2} w="100%" align="stretch">
          <Text fontSize="sm" fontWeight="600" color="gray.800">Description (optional)</Text>
          <Textarea
            placeholder="Describe what this scenario is for..."
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={4}
            resize="vertical"
            data-testid="wizard-scenario-description"
          />
        </VStack>

        <Button
          size="lg"
          bg="brand.500"
          color="white"
          fontWeight="bold"
          w="100%"
          mt={4}
          onClick={handleSubmit}
          isDisabled={!name.trim() || isLoading}
          data-testid="wizard-scenario-submit"
          _hover={{ bg: 'brand.600' }}
        >
          {isLoading ? 'Saving...' : 'Continue'}
        </Button>
      </VStack>
    </VStack>
  );
}

export default ScenarioStep;
